import moment from "moment"

// Caching on Local Storage to persist even on closing of browsers
export const cacheData = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ ...data, timestamp: moment() }))
  } catch (err) {
    console.log("Error in caching: ", err)
  }
}

export const getCachedData = key => {
  try {
    const cachedData = JSON.parse(localStorage.getItem(key))
    const now = moment()
    const timestamp =
      cachedData && cachedData.timestamp
        ? moment(cachedData.timestamp)
        : moment()
    if (now.diff(timestamp, "days") < 3) {
      return cachedData
    } else {
      removeCachedData(key)
      return null
    }
  } catch (err) {
    console.log("Error in loading cache: ", err)
  }
}

export const removeCachedData = key => {
  try {
    localStorage.removeItem(key)
  } catch (err) {
    console.log("Error in removing cache: ", err)
  }
}

//Cache data for in Session Storage to persist page reloads
export const sessionData = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data))
  } catch (err) {
    console.log("Error in session caching: ", err)
  }
}

export const getSessionData = key => {
  try {
    const sessionData = sessionStorage.getItem(key)
    return JSON.parse(sessionData)
  } catch (err) {
    console.log("Error in getting session cache: ", err)
  }
}

export const removeSessionData = key => {
  try {
    sessionStorage.removeItem(key)
  } catch (err) {
    console.log("Error in removing session cache: ", err)
  }
}

export default cacheData
